import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';

import { RadioButton } from '@lt/components';
import type { SortSubType } from '../../../../types';
import { TEST_ID_SEARCH_SORT_OPTION } from './constants';
import { getDataState } from '../../../../utils';

interface Props {
  id: string;
  currentType: SortSubType;
  onClick(id: string, type: SortSubType): void;
  types: SortSubType[];
}

export const SortTypeList: FC<Props> = ({
  id,
  onClick,
  currentType,
  types,
}) => (
  <>
    {types.map((type) => {
      const isActive = currentType.label === type.label;
      const isDesc = type.order === 'desc';
      return (
        <StyledTypesItem
          data-testid={`${TEST_ID_SEARCH_SORT_OPTION}_${id}_${type.order}`}
          data-state={getDataState(isActive, isDesc)}
          type="button"
          key={`${id}${type.order}`}
          onClick={() => onClick(id, type)}
        >
          {type.label}
          <RadioButton
            value={`${id}${type.order}`}
            name="sort_type"
            checked={isActive}
            data-testid={`RADIO_BUTTON_${id}_${type.order}`}
            data-state={getDataState(isActive, isDesc)}
          />
        </StyledTypesItem>
      );
    })}
  </>
);

const StyledTypesItem = styled.button`
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 8px 6px;

  font-size: 18px;
  line-height: 22px;
  border: none;
`;
